import React from 'react';
import { ArrowUpRightIcon, BarChart3Icon, BookOpenIcon, CreditCardIcon, DatabaseIcon, KeyRoundIcon, LinkIcon, MessageSquareIcon, MicIcon, SearchIcon, SendIcon, ShieldIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import type { AccessMode, Tool } from '../types/project';
const ICONS: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  database: DatabaseIcon,
  chart: BarChart3Icon,
  message: MessageSquareIcon,
  mic: MicIcon,
  book: BookOpenIcon,
  users: UsersIcon,
  card: CreditCardIcon,
  search: SearchIcon,
  send: SendIcon,
  shield: ShieldIcon,
  link: LinkIcon,
  sparkles: SparklesIcon
};
const ACCESS_LABEL: Record<AccessMode, string> = {
  sso: 'Google SSO',
  shared: 'Shared login',
  request: 'Request access',
  personal: 'Your own email',
  open: 'Log in'
};
interface ToolCardProps {
  tool: Tool;
}
export function ToolCard({
  tool
}: ToolCardProps) {
  const Icon = ICONS[tool.icon] ?? LinkIcon;
  const accented = tool.access !== 'request';
  return <a href={tool.url} target="_blank" rel="noreferrer noopener" style={{
    borderRadius: 'var(--b-radius)'
  }} className="group flex flex-col border border-[var(--b-border)] bg-[var(--b-surface)] p-5 transition hover:-translate-y-0.5 hover:border-[var(--b-accent)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--b-accent)]" data-id="element-175" data-mp="kn2zgtl1q3cx">
      <div className="flex items-start justify-between gap-3" data-id="element-176" data-mp="xirflcs8z5y">
        <span style={{
        borderRadius: 'var(--b-radius)'
      }} className="flex h-10 w-10 items-center justify-center border border-[var(--b-border)] bg-[var(--b-surface-alt)] text-[var(--b-dim)] transition group-hover:border-[var(--b-accent)] group-hover:text-[var(--b-accent)]" data-id="element-177" data-mp="5ohbmw0w6heh">
          <Icon className="h-4 w-4" data-id="element-178" data-mp="3e4aq75bnxisw" />
        </span>
        <ArrowUpRightIcon className="h-4 w-4 shrink-0 text-[var(--b-dim)] transition group-hover:text-[var(--b-accent)]" aria-hidden="true" data-id="element-179" data-mp="3e5lynig1zeqc" />
      </div>

      <h3 className="mt-4 text-sm font-semibold text-[var(--b-text)]" data-id="element-180" data-mp="2zztzt2e7ganb">{tool.name}</h3>
      <p className="mt-1.5 flex-1 text-xs leading-relaxed text-[var(--b-dim)]" data-id="element-181" data-mp="2v7is3dd83kk7">
        {tool.description}
      </p>

      <div className="mt-4 flex flex-wrap items-center gap-2" data-id="element-182" data-mp="2qa0m9vui5lgf">
        <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--b-dim)]" data-id="element-183" data-mp="2la4jfzxjk02g">
          {tool.category}
        </span>
        <span className="rounded-full border px-2 py-0.5 text-[10px] font-medium" style={accented ? {
        backgroundColor: 'var(--b-tint)',
        borderColor: 'var(--b-accent)',
        color: 'var(--b-accent)'
      } : {
        backgroundColor: 'var(--b-surface-alt)',
        borderColor: 'var(--b-border)',
        color: 'var(--b-dim)'
      }} data-id="element-184" data-mp="3iwbp7d5kzyge">
          {ACCESS_LABEL[tool.access]}
        </span>
      </div>

      {tool.credentialHint && <p className="mt-3 flex items-center gap-1.5 border-t border-[var(--b-border)] pt-3 font-mono text-[10px] text-[var(--b-dim)]" data-id="element-185" data-mp="84zkhnq6bytm">
          <KeyRoundIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-186" data-mp="i1m3e6yxwft0" />
          {tool.credentialHint}
        </p>}
    </a>;
}